var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file)?_c('base-button',{attrs:{"size":"sm","type":_vm.file.completed_at ? 'success' : 'primary',"outline":!!_vm.file.completed_at,"disabled":_vm.saving || _vm.locked},on:{"click":_vm.toggle}},[_c('i',{staticClass:"mr-1",class:_vm.icon}),_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }